import {
	LoginContainer,
	SignUpContainer,
	OTPContainer,
	ForgetPasswordContainer,
	ResetPasswordContainer,
	OnboardingContainerOne,
	OnboardingContainerTwo,
	CheckoutContainer,
	// ProductCheckOutFilledContainer,
	ProductDisplayContainer,
	ProductCheckOutContainer,
	MimaCheckoutContainer,
	PaymentLinkCheckoutContainer,
	BookingLinkDetailsContainer,
	BlogLandingContainer,
	BlogSingleContainer,
	CatalogueContainer,
	ViewMoreDesignContainer,
	FxTransferContainer,
} from '../containers';

import PasswordChangeSuccess from '../pages/ResetPassword/PasswordChangeSuccess';
import AlmostThere3 from '../pages/Onboarding/AlmostThere3';
import LandingPage from '../pages/LandingPage/LandingPage';
import Error404 from '../pages/Error/Error404';
import constant from '../utils/constant';
import { AccountInReview, RefundPolicy, TermsOfService } from '../pages';
import Faqs from '../pages/LandingPage/Faqs';
import About from '../pages/LandingPage/About';
import Terms from '../pages/LandingPage/Terms';
import Privacy from '../pages/LandingPage/Privacy';
import Contact from '../pages/LandingPage/Contact';
import Article from '../pages/LandingPage/Article';
import Article1 from '../pages/LandingPage/Article1';
import Article2 from '../pages/LandingPage/Article2';
import Article3 from '../pages/LandingPage/Article3';
import Article4 from '../pages/LandingPage/Article4';
import Article5 from '../pages/LandingPage/Article5';

const openRoutes = [
	{
		path: constant.Routes.Home,
		element: <LandingPage />,
	},
	{
		path: constant.Routes.Login,
		element: <LoginContainer />,
	},

	{
		path: constant.Routes.SignUp,
		element: <SignUpContainer />,
	},
	{
		path: constant.Routes.Checkout,
		element: <CheckoutContainer />,
	},

	{
		path: constant.Routes.ForgetPassword,
		element: <ForgetPasswordContainer />,
	},

	{
		path: constant.Routes.Otp,
		element: <OTPContainer />,
	},

	{
		path: constant.Routes.ResetPassword,
		element: <ResetPasswordContainer />,
	},
	{
		path: constant.Routes.ResetPasswordChangeSuccess,
		element: <PasswordChangeSuccess />,
	},
	{
		path: constant.Routes.OnboardingStageOne,
		element: <OnboardingContainerOne />,
	},

	{
		path: constant.Routes.OnboardingStageTwo,
		element: <OnboardingContainerTwo />,
	},

	{
		path: constant.Routes.AlmostThereThree,
		element: <AlmostThere3 />,
	},
	{
		path: constant.Routes.Error404,
		element: <Error404 />,
	},
	// {
	// 	path: constant.Routes.Checkout,
	// 	element: <CheckoutContainer />,
	// },
	{
		path: constant.Routes.ProductDisplay,
		element: <ProductDisplayContainer />,
	},
	{
		path: constant.Routes.ProductCheckOut,
		element: <ProductCheckOutContainer />,
	},
	{
		path: constant.Routes.MimaCheckout,
		element: <MimaCheckoutContainer />,
	},
	{
		path: constant.Routes.PaymentLinkCheckout,
		element: <PaymentLinkCheckoutContainer />,
	},
	{
		path: constant.Routes.AccountInReview,
		element: <AccountInReview />,
	},
	{
		path: constant.Routes.MakeBookings,
		element: <BookingLinkDetailsContainer />,
	},
	{
		path: constant.Routes.Faqs,
		element: <Faqs />,
	},
	{
		path: constant.Routes.About,
		element: <About />,
	},
	{
		path: constant.Routes.Terms,
		element: <Terms />,
	},
	{
		path: constant.Routes.Privacy,
		element: <Privacy />,
	},
	{
		path: constant.Routes.Contact,
		element: <Contact />,
	},
	{
		path: constant.Routes.Article,
		element: <Article />,
	},
	{
		path: constant.Routes.Article1,
		element: <Article1 />,
	},
	{
		path: constant.Routes.Article2,
		element: <Article2 />,
	},
	{
		path: constant.Routes.Article3,
		element: <Article3 />,
	},
	{
		path: constant.Routes.Article4,
		element: <Article4 />,
	},
	{
		path: constant.Routes.Article5,
		element: <Article5 />,
	},
	{
		path: constant.Routes.BlogLanding,
		element: <BlogLandingContainer />,
	},
	{
		path: constant.Routes.BlogSinglePost,
		element: <BlogSingleContainer />,
	},
	{
		path: constant.Routes.Catalogue,
		// type: 'GENERAL',
		element: <CatalogueContainer />,
	},
	{
		path: constant.Routes.ViewMoreDesign,
		// type: 'GENERAL',
		element: <ViewMoreDesignContainer />,
	},
	{
		path: constant.Routes.Catalogue,
		// module: 'TRANSACTION',
		type: 'GENERAL',
		element: <CatalogueContainer />,
	},
	{
		path: constant.Routes.FxTransferCheckout,
		element: <FxTransferContainer />,
	},
	{
		path: constant.Routes.TermsOfService,
		element: <TermsOfService />,
	},
	{
		path: constant.Routes.RefundPolicy,
		element: <RefundPolicy />,
	},
];

export default openRoutes;
